import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import "./index.css";
import App from "./App";
import Penalty from "./pages/Penalty";
import Auth from "./pages/Auth";
import Home from "./pages/Home";

import NotFound from "./pages/NotFound";
import AppProvider from "./AppProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <AppProvider>
        <Routes>
          {/* <Route path="/" element={<Navigate to="/penalty" />}></Route> */}
          {/* <Route path="login" element={<Login />}></Route> */}
          <Route path="c/:id" element={<Auth />}></Route>
          <Route path="p/:id" element={<Penalty />}></Route>
          <Route path="app" element={<App />}>
            <Route path="home" element={<Home></Home>}></Route>
          </Route>
          <Route path="*" element={<NotFound />}></Route>
        </Routes>
      </AppProvider>
    </React.StrictMode>
  </BrowserRouter>
);
